const bus_stop_loc =
    [   
        { "name": 'DMS', "latitude": '28.54272440568811', "longitude": "77.18237447428189" },
        { "name": 'Nilgiri', "latitude": '28.546146847749608', "longitude": "77.18290812404115" },
        { "name": 'Karakoram', "latitude": '28.547205365457206', "longitude": "77.18346304433106" },
        { "name": 'Aravali', "latitude": '28.54819290212597', "longitude": "77.18402502490731" },
        { "name": 'Jwalamukhi', "latitude": '28.549077483842204', "longitude": "77.1844279189429" },
        { "name": 'Vindyachal', "latitude": '28.548598379185762', "longitude": "77.18566593623335" },
        { "name": 'Shivalik', "latitude": '28.54783145333011', "longitude": "77.1854667809046" },
        { "name": 'Zanskar', "latitude": '28.547207129632188', "longitude": "77.1852651383828" },
        { "name": 'Rajdhani', "latitude": '28.546115506227973', "longitude": "77.18668303818497" },
        { "name": 'IITD Hospital', "latitude": '28.545478033135616', "longitude": "77.18825730902766" },
        { "name": 'Bharti School', "latitude": '28.54481290585897', "longitude": "77.18980931702562" },
        { "name": 'LHC', "latitude": '28.544454985271045', "longitude": "77.1927197643454" },
        { "name": 'Kailash', "latitude": '28.544052861819047', "longitude": "77.19618498916329" },
        { "name": 'IITD Market', "latitude": '28.542952417278926', "longitude": "77.19901037361504" },
    ]
export default bus_stop_loc